import { Suspense, type JSX } from "react";
import { RouteObject, redirect } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

// import { TrainingPageSkeleton } from "@/components/Training/TrainingPageSkeleton";

const wrapWithSentry = (Component: JSX.Element) => (
	<Sentry.ErrorBoundary
		fallback={({ error, componentStack, resetError }) => (
			<PageError
				error={error}
				componentStack={componentStack}
				reset={resetError}
			/>
		)}
	>
		{/* <Suspense fallback={null /* or <TrainingPageSkeleton /> */}
		{Component}
		{/* </Suspense> */}
	</Sentry.ErrorBoundary>
);

export const TrainingRoutes: RouteObject = {
	path: "/training/*",
	lazy: async () => {
		const { TrainingPage } = await import("@/components/Training/TrainingPage");
		return {
			Component: () => wrapWithSentry(<TrainingPage />),
		};
	},
	children: [
		{
			index: true,
			loader: () => redirect("/training/dashboard"),
		},
		{
			path: "dashboard",
			lazy: async () => {
				const { TrainingPage } = await import(
					"@/components/Training/TrainingPage"
				);
				return {
					Component: () => wrapWithSentry(<TrainingPage tabIndex={0} />),
				};
			},
		},
		{
			path: "courses/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { TrainingPage } = await import(
							"@/components/Training/TrainingPage"
						);
						return {
							Component: () => wrapWithSentry(<TrainingPage tabIndex={1} />),
						};
					},
				},
				{
					path: ":courseId/*",
					children: [
						{
							index: true,
							lazy: async () => {
								const { TrainingPage } = await import(
									"@/components/Training/TrainingPage"
								);
								return {
									Component: () =>
										wrapWithSentry(<TrainingPage tabIndex={1} />),
								};
							},
						},
						{
							path: "archive",
							lazy: async () => {
								const { TrainingPage } = await import(
									"@/components/Training/TrainingPage"
								);
								return {
									Component: () =>
										wrapWithSentry(<TrainingPage tabIndex={3} />),
								};
							},
						},
						{
							path: "sessions/:sessionId",
							lazy: async () => {
								const { TrainingPage } = await import(
									"@/components/Training/TrainingPage"
								);
								return {
									Component: () =>
										wrapWithSentry(<TrainingPage tabIndex={1} />),
								};
							},
						},
					],
				},
			],
		},
		{
			path: "drills/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { TrainingPage } = await import(
							"@/components/Training/TrainingPage"
						);
						return {
							Component: () => wrapWithSentry(<TrainingPage tabIndex={2} />),
						};
					},
				},
				{
					path: ":drillId/*",
					children: [
						{
							index: true,
							lazy: async () => {
								const { TrainingPage } = await import(
									"@/components/Training/TrainingPage"
								);
								return {
									Component: () =>
										wrapWithSentry(<TrainingPage tabIndex={2} />),
								};
							},
						},
						{
							path: "sessions/:sessionId",
							lazy: async () => {
								const { TrainingPage } = await import(
									"@/components/Training/TrainingPage"
								);
								return {
									Component: () =>
										wrapWithSentry(<TrainingPage tabIndex={2} />),
								};
							},
						},
						{
							path: "ArchivedSessions",
							lazy: async () => {
								const { TrainingPage } = await import(
									"@/components/Training/TrainingPage"
								);
								return {
									Component: () =>
										wrapWithSentry(<TrainingPage tabIndex={3} />),
								};
							},
						},
					],
				},
			],
		},
		{
			path: "archive/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { TrainingPage } = await import(
							"@/components/Training/TrainingPage"
						);
						return {
							Component: () => wrapWithSentry(<TrainingPage tabIndex={3} />),
						};
					},
				},
				{
					path: "kpiParameters/:kpiParameterId",
					lazy: async () => {
						const { TrainingPage } = await import(
							"@/components/Training/TrainingPage"
						);
						return {
							Component: () => wrapWithSentry(<TrainingPage tabIndex={3} />),
						};
					},
				},
				{
					path: ":sessionId",
					lazy: async () => {
						const { TrainingPage } = await import(
							"@/components/Training/TrainingPage"
						);
						return {
							Component: () => wrapWithSentry(<TrainingPage tabIndex={3} />),
						};
					},
				},
			],
		},
		{
			path: "planner/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { TrainingPage } = await import(
							"@/components/Training/TrainingPage"
						);
						return {
							Component: () => wrapWithSentry(<TrainingPage tabIndex={4} />),
						};
					},
				},
			],
		},
	],
};
